import {
    HiOutlineExclamationCircle,
    HiOutlineQuestionMarkCircle,
} from 'react-icons/hi2';
import { twMerge } from 'tailwind-merge';
import { StyledTooltip, StyledTooltipContainer } from './styles';
import { TooltipProps } from './types';
import { ETooltipIntents, ETypographyIntents } from '@src/typings';
import { Typography } from '../Typography';
import { TooltipVariants } from '@src/utilities/tooltipVariants';

export const Tooltip = ({
    title,
    className,
    intent = ETooltipIntents.Info,
    color = 'primary',
}: TooltipProps) => {
    return (
        <StyledTooltip
            trigger="click"
            title={
                <Typography intent={ETypographyIntents.Regular}>
                    {title}
                </Typography>
            }
            arrow={false}
        >
            <StyledTooltipContainer
                $color={color}
                className={twMerge(
                    TooltipVariants({
                        className,
                        intent,
                        color,
                    })
                )}
            >
                {intent === ETooltipIntents.Info ? (
                    <HiOutlineExclamationCircle className="min-w-4 min-h-4 text-base" />
                ) : (
                    <HiOutlineQuestionMarkCircle className="min-w-4 min-h-4 text-base" />
                )}
            </StyledTooltipContainer>
        </StyledTooltip>
    );
};
